import { createVariableProperty } from '../core';
export const size = {
    properties: {
        'padding-top': createVariableProperty('padding-top'),
        'padding-bottom': createVariableProperty('padding-bottom')
    }
};

//# sourceMappingURL=size.js.map